/* eslint-disable no-console */
import { sessionHttpModule } from '@shared/http';
import { httpModule } from '@shared/http';

export interface Organization {
    id: number;
    name: string;
    logo: string;
    description: string;
    email: string;
    phone: string;
    website: string;
    address: any;
    signature: string;
}

export async function logIn(username: string, password: string) {
    try {
        return await sessionHttpModule.post('auth/login', {}, {
            data: {
                username,
                password
            }
        });
    } catch (ex) {
        console.warn('Login error');
        console.log(ex.response);
    }
}

export async function postRegister(payload: any) {
    try {
        return await sessionHttpModule.post('users/register', payload);
    } catch (ex) {
        console.log(ex.response);
        return Promise.reject('Register error');
    }
}

export async function recoveryPass(email: string) {
    try {
        return await sessionHttpModule.post('reset', {}, {
            data: {
                email
            }
        });
    } catch (ex) {
        console.warn('recovery error');
        console.log(ex.response);
    }
}

export async function ChangePass(password: string, session:string, code:string) {
    try {
        return await sessionHttpModule.put(`reset?sesion=${session}&code=${code}`, {
            password
        });
    } catch (ex) {
        console.warn('Change pass error');
        console.log(ex.response);
    }
}

export async function getOrganizationData() {
    try {
        return await httpModule.get('organizations/me');
    } catch (ex) {
        console.warn('Error fetching organization\'s data');
        console.log(ex);
    }
}